import { render, staticRenderFns } from "./TCSModal.vue?vue&type=template&id=33b02e05&scoped=true"
import script from "./TCSModal.vue?vue&type=script&lang=js"
export * from "./TCSModal.vue?vue&type=script&lang=js"
import style0 from "./TCSModal.vue?vue&type=style&index=0&id=33b02e05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b02e05",
  null
  
)

export default component.exports